import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {FormSelectItem} from '../../../model/form/select-item.model';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-dialog-select-young-inscription-duplicate',
    templateUrl: './dialog-select-young-inscription-duplicate.component.html',
    styleUrls: ['./dialog-select-young-inscription-duplicate.component.scss'],
    imports: [MatDialogTitle, NgFor, FormsModule, MatButtonModule]
})
export class DialogSelectYoungInscriptionDuplicateComponent implements OnInit, OnDestroy {
    dialogRef = inject<MatDialogRef<DialogSelectYoungInscriptionDuplicateComponent>>(MatDialogRef);
    data = inject<{
    duplicates: unknown;
}>(MAT_DIALOG_DATA);


    result;
    abort = true;
    duplicates: Array<FormSelectItem> = [];

    ngOnInit() {
        if (this.data.duplicates && Array.isArray(this.data.duplicates)) {
            this.duplicates = this.data.duplicates;
        }
        if (!this.duplicates || this.duplicates.length === 0) {
            this.dialogRef.close(-1);
        }
    }


    createYoung() {
        this.result = 0;
        this.abort = false;
        this.dialogRef.close();
    }

    exit() {
        this.abort = false;
        this.dialogRef.close();
    }

    abortAction() {
        this.abort = true;
        this.dialogRef.close();
    }

    ngOnDestroy() {
        // Exit without choose young or create new
        if (this.abort) {
            this.dialogRef.close(-1);
        } else {
            this.dialogRef.close(this.result);
        }
    }
}
